import {
	NOTIFICATION_INIT,
	NOTIFICATION_LOADED,
	NOTIFICATION_LOADING,
	NOTIFICATION_LOADING_FAILED
} from "../actions/types";
const initialState = {
	isLoading: false,
	isLoaded: false,
	isfailed: false,
	notifications: {},
};

export default function (state = initialState, action) {
	switch (action.type) {
		case NOTIFICATION_LOADED:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				isfailed: false,
				notifications: action.payload,
			};
		case NOTIFICATION_LOADING_FAILED:
			return {
				...state,
				isLoading: false,
				isfailed: true,
				isLoaded: false,
			};
		case NOTIFICATION_LOADING:
			return {
				...state,
				isLoading: true,
				isfailed: false,
				isLoaded: false,
			};
			case NOTIFICATION_INIT:
				return {
			isLoading: false,
	isLoaded: false,
	isfailed: false,
	notifications: {},
				}

		default:
			return state;
	}
}
